
import { defineComponent, onMounted, onBeforeUnmount } from "vue"
import * as echarts from "echarts";

export default defineComponent({
  setup() {
    let scatterData: (string | number)[][] = []
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let pieData = []
    let statisticDict = {}
    let markerSize = 2
    let selectCellNames: string[] = []
    let polygonData: number[][] = []

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let scatterPlot
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let piePlot

    /**
     * 获取Scatter图的配置选项
     */
    const getScatterOption = () => {
      return {
        animation: false,
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: 'save as image',
              type: 'png'
            },
            dataZoom: {
              title : {zoom : "zoom", back: "back"},
              show: true
            },
            myBrushPolygonSelect: {
              show: true,
              title: 'PolygonSelect, double click to end selection',
              icon: 'path://M0 100 L125 0 L300 0 L330 200 L100 200 Z',
              onclick: () => {
                console.log('PolygonSelect')
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot?.getZr()?.on('click', (event) => {
                  polygonData.push([event.event.zrX, event.event.zrY])
                  console.log("ployData", polygonData)
                  if (polygonData.length > 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    scatterPlot?.dispatchAction({
                      type: 'brush',
                      areas: [
                        {
                          // 指定选框的类型。可以为 'polygon', 'rect', 'lineX', 'lineY'
                          brushType: 'polygon',
                          // 如果是“全局选框”，则使用 range 来描述选框的范围（里面是像素坐标）。
                          range: polygonData.slice(1)
                        }
                      ]
                    })
                  }
                })
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot?.getZr()?.on('dblclick', (event) => {
                  console.log('dblclick')
                  polygonData = []
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot?.getZr()?.off('click')
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot?.getZr()?.off('dblclick')
                })
              }
            },
            brush : {
              type: ["rect", "polygon", "keep", 'clear'],
              title : {
                rect: "rect",
                polygon: "polygon",
                keep : "keep",
                clear: "clear"
              }
            },
          }
        },
        dataset: {
          dimensions: ['x', 'y', 'cell_name'],
          source: scatterData
        },
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Annotation View',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter: (params: any) => {
            const data = params.data
            return 'x: ' + Number(data[0]).toFixed(2) + ' <br> y: '
                + Number(data[1]).toFixed(2) + '<br> cell name: '
                + data[2]
          }
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
        },
        brush: {
          inBrush: {
            opacity: 1
          },
          throttleType: 'debounce',
          throttleDelay: 1000,
        },
        series: {
          type: 'scatter',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: scatterData,
          symbolSize: markerSize,
          itemStyle: {
            color: (params: any) => {
              if (selectCellNames.indexOf(params.data[2]) === -1) {
                return 'rgb(127, 127, 127)'
              }
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              return statisticDict[params.data[2]]
            }
          }
        },
      }
    }

    /**
     * 获取Pie图的配置选项
     */
    const getPieOption = () => {
      return {
        animation: false,
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              type: 'png'
            }
          }
        },
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Statistics',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: (params: any) => {
            const data = params.data
            return 'name: ' + data.name + ' <br> count: ' + data.value
          }
        },
        series: {
          type: 'pie',
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          data: pieData,
          itemStyle: {
            color: (params: any) => {
              console.log(params.data)
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              return statisticDict[params.data.name]
            }
          }
        }
      }
    }

    /**
     * 从列表获取饼图需要的数据，即获取有多少种cell name以及它们对应的个数
     * @param data 散点数据列表
     */
    const retrievePieData = (data: (string | number)[][]) => {
      let result: any = []
      let groups = new Map<string, number>()
      for (let i = 0; i < data.length; i++) {
        if (data[i][0] === 'x') {
          continue;
        }
        let k = String(data[i][2])
        if (groups.has(k)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          groups.set(k, groups.get(k) + 1)
        } else {
          groups.set(k, 1)
        }
      }
      console.log('group', groups)
      groups.forEach((v, k) => {
        result.push({
          value: v,
          name: k
        })
      })
      console.log('result', result)
      return result
    }

    /**
     * brush选择的回调函数
     * @param params 存放选择索引的一个参数
     */
    const renderBrushed = (params: any) => {
      console.log('aa')
      let selectedIndex = params.batch[0].selected[0].dataIndex
      console.log(selectedIndex)
      let selectedData = []
      if (selectedIndex.length > 0){
        for (let index of selectedIndex) {
          selectedData.push(scatterData[index])
        }
        console.log(selectedData)
        pieData = retrievePieData(selectedData)
        updatePiePlot()
      } else {
        console.log('not in ', selectedIndex.length)
        pieData = retrievePieData(scatterData)
        updatePiePlot()
      }
    }

    /**
     * 更新散点图
     */
    const updateScatterPlot = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.setOption(getScatterOption(), true)
    }

    /**
     * 更新饼图
     */
    const updatePiePlot = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      piePlot?.setOption(getPieOption(), true)
      console.log('update pie')
    }

    /**
     * 初始化设置散点图和饼图的数据
     * @param data
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const setPlotData = (data) => {
      scatterData = data['gene_attribute_plot']
      selectCellNames = data['gene_statistics'].map((item: any) => {
        return item['cell_name']
      })
      console.log('scatter data', scatterData)
      pieData = []
      for (let i = 0; i < data['gene_statistics'].length; i++) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        statisticDict[data['gene_statistics'][i]['cell_name']] = data['gene_statistics'][i]['color']
        pieData.push({
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          value: data['gene_statistics'][i]['count'],
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          name: String(data['gene_statistics'][i]['cell_name'])
        })
      }
      console.log('dict data', statisticDict)
      updateScatterPlot()
      updatePiePlot()
    }

    /**
     * 改变散点图的点大小
     * @param size
     */
    const changeMarkerSize = (size: number) => {
      markerSize = size
      console.log('marker size: ', markerSize)
      updateScatterPlot()
    }

    /**
     * 以cell name为基础来选择对应的散点
     * @param items 选择的cell name列表
     */
    const selectByCellNames = (items: string[]) => {
      selectCellNames = items
      let selectedData = []
      for (let i = 0; i < scatterData.length; i++) {
        if (selectCellNames.indexOf(String(scatterData[i][2])) !== -1) {
          selectedData.push(scatterData[i])
        }
      }
      pieData = retrievePieData(selectedData)
      updateScatterPlot()
      updatePiePlot()
    }

    /**
     * 当窗口变化时用来调整图的大小
     */
    const resizePlot = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.resize()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      piePlot?.resize()
    }

    onMounted(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot = echarts.init(document.getElementById('geneAttributeViewScatterPlot'))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.on('brushselected', renderBrushed)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      piePlot = echarts.init(document.getElementById('geneAttributeViewPiePlot'))
      window.addEventListener('resize', resizePlot)
    })

    onBeforeUnmount(() => {
      console.log('attribute onBeforeUnmount')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.off('brushselected')
      window.removeEventListener('resize', resizePlot)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot.dispose()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      piePlot.dispose()
    })

    return {
      setPlotData,
      changeMarkerSize,
      selectByCellNames
    }
  }
})

